/*
Font Awesome Free License
-------------------------

Font Awesome Free is free, open source, and GPL friendly. You can use it for
commercial projects, open source projects, or really almost whatever you want.
Full Font Awesome Free license: https://fontawesome.com/license/free.

# Icons: CC BY 4.0 License (https://creativecommons.org/licenses/by/4.0/)
In the Font Awesome Free download, the CC BY 4.0 license applies to all icons
packaged as SVG and JS file types.

# Fonts: SIL OFL 1.1 License (https://scripts.sil.org/OFL)
In the Font Awesome Free download, the SIL OFL license applies to all icons
packaged as web and desktop font files.

# Code: MIT License (https://opensource.org/licenses/MIT)
In the Font Awesome Free download, the MIT license applies to all non-font and
non-icon files.

# Attribution
Attribution is required by MIT, SIL OFL, and CC BY licenses. Downloaded Font
Awesome Free files already contain embedded comments with sufficient
attribution, so you shouldn't need to do anything additional when using these
files normally.

We've kept attribution comments terse, so we ask that you do not actively work
to remove them from files, especially code. They're a great way for folks to
learn about Font Awesome.

# Brand Icons
All brand icons are trademarks of their respective owners. The use of these
trademarks does not indicate endorsement of the trademark holder by Font
Awesome, nor vice versa. **Please do not use brand logos for any purpose except
to represent the company, product, or service to which they refer.**
*/
package com.bikompanion.ui.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val FontAwesomeWarehouse: ImageVector
    get() {
        if (_FontAwesomeWarehouse != null) return _FontAwesomeWarehouse!!

        _FontAwesomeWarehouse = ImageVector
            .Builder(
                name = "warehouse",
                defaultWidth = 24.dp,
                defaultHeight = 24.dp,
                viewportWidth = 640f,
                viewportHeight = 512f,
            ).apply {
                path(
                    fill = SolidColor(Color.Black),
                ) {
                    moveTo(504f, 352f)
                    horizontalLineTo(136.4f)
                    curveToRelative(-4.4f, 0f, -8f, 3.6f, -8f, 8f)
                    lineToRelative(-0.1f, 48f)
                    curveToRelative(0f, 4.4f, 3.6f, 8f, 8f, 8f)
                    horizontalLineTo(504f)
                    curveToRelative(4.4f, 0f, 8f, -3.6f, 8f, -8f)
                    verticalLineToRelative(-48f)
                    curveToRelative(0f, -4.4f, -3.6f, -8f, -8f, -8f)
                    close()
                    moveToRelative(0f, 96f)
                    horizontalLineTo(136.1f)
                    curveToRelative(-4.4f, 0f, -8f, 3.6f, -8f, 8f)
                    lineToRelative(-0.1f, 48f)
                    curveToRelative(0f, 4.4f, 3.6f, 8f, 8f, 8f)
                    horizontalLineToRelative(368f)
                    curveToRelative(4.4f, 0f, 8f, -3.6f, 8f, -8f)
                    verticalLineToRelative(-48f)
                    curveToRelative(0f, -4.4f, -3.6f, -8f, -8f, -8f)
                    close()
                    moveToRelative(0f, -192f)
                    horizontalLineTo(136.6f)
                    curveToRelative(-4.4f, 0f, -8f, 3.6f, -8f, 8f)
                    lineToRelative(-0.1f, 48f)
                    curveToRelative(0f, 4.4f, 3.6f, 8f, 8f, 8f)
                    horizontalLineTo(504f)
                    curveToRelative(4.4f, 0f, 8f, -3.6f, 8f, -8f)
                    verticalLineToRelative(-48f)
                    curveToRelative(0f, -4.4f, -3.6f, -8f, -8f, -8f)
                    close()
                    moveToRelative(106.5f, -139f)
                    lineTo(338.4f, 3.7f)
                    arcToRelative(48.15f, 48.15f, 0f, false, false, -36.9f, 0f)
                    lineTo(29.5f, 117f)
                    curveTo(11.7f, 124.5f, 0f, 141.9f, 0f, 161.3f)
                    verticalLineTo(504f)
                    curveToRelative(0f, 4.4f, 3.6f, 8f, 8f, 8f)
                    horizontalLineToRelative(80f)
                    curveToRelative(4.4f, 0f, 8f, -3.6f, 8f, -8f)
                    verticalLineTo(256f)
                    curveToRelative(0f, -17.6f, 14.6f, -32f, 32.6f, -32f)
                    horizontalLineToRelative(382.8f)
                    curveToRelative(18f, 0f, 32.6f, 14.4f, 32.6f, 32f)
                    verticalLineToRelative(248f)
                    curveToRelative(0f, 4.4f, 3.6f, 8f, 8f, 8f)
                    horizontalLineToRelative(80f)
                    curveToRelative(4.4f, 0f, 8f, -3.6f, 8f, -8f)
                    verticalLineTo(161.3f)
                    curveToRelative(0f, -19.4f, -11.7f, -36.8f, -29.5f, -44.3f)
                    close()
                }
            }.build()

        return _FontAwesomeWarehouse!!
    }

private var _FontAwesomeWarehouse: ImageVector? = null
